import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import Select from '@atlaskit/select';
import { N20 } from '@atlaskit/theme/colors';
import { DisplayMode } from '../../RenderForm';
import { ViewWrapper } from '../common/questionWrappers';
export var ViewUserPicker = function ViewUserPicker(_ref) {
  var id = _ref.id,
    isMulti = _ref.isMulti,
    value = _ref.value,
    displayMode = _ref.displayMode;
  if (displayMode === DisplayMode.Edit || displayMode === DisplayMode.Preview || displayMode === DisplayMode.Translate) {
    // This is a Disabled Select
    return /*#__PURE__*/React.createElement(Select, {
      id: id,
      value: value,
      isMulti: isMulti,
      isDisabled: true,
      styles: {
        control: function control(base) {
          return _objectSpread(_objectSpread({}, base), {}, {
            backgroundColor: "var(--ds-background-accent-gray-subtlest, ".concat(N20, ")"),
            borderColor: "var(--ds-border-disabled, #DFE1E6)",
            color: "var(--ds-text, #172B4D !important)"
          });
        },
        menu: function menu(base) {
          return _objectSpread(_objectSpread({}, base), {}, {
            color: "var(--ds-text-subtle, #172B4D)"
          });
        }
      },
      isClearable: true,
      defaultOptions: true,
      placeholder: ""
    });
  }
  return /*#__PURE__*/React.createElement(ViewWrapper, null, value && value.map(function (item) {
    return item.label;
  }).join(', '));
};